angular.module('mercury.modules.stock.item')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.Item', {
    url: '/items',
    templateUrl: 'modules/stock/item/list.tpl.html',
    controller: 'StockItemListCtrl'
  })
  .state('Stock.Item.StockPrice', {
    url: '/price/:itemId/:quantity/:unitName/:unitRatio',
    data: {
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/stocktake/pricebox.tpl.html',
        controller: 'StockStocktakePriceboxCtrl'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });
}]);
